import http from '@/http'
import VideoRoom from '@/store/models/VideoRoom'
import { serializeObjectToQueryParameter } from '@/store/helper'

const API_PATH = 'organizations/:organizationId/video_room_masters/:videoRoomMasterId/video_rooms/'
const INVITED_API_PATH = 'organizations/:organizationId/user_organization/video_rooms/'

const configureApiPath = ({ organizationId, videoRoomMasterId }) => {
  return API_PATH.replace(':organizationId', organizationId)
                 .replace(':videoRoomMasterId', videoRoomMasterId)
}

const configureInvitedApiPath = ({ organizationId }) => {
  return INVITED_API_PATH.replace(':organizationId', organizationId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async index({ commit, rootGetters }, payload) {
    const { videoRoomMasterId, params } = payload
    VideoRoom.delete(videoRoom => {
      return videoRoom.videoRoomMasterId == videoRoomMasterId
    })
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      videoRoomMasterId: videoRoomMasterId
    })
    await http.get(apiPath + serializeObjectToQueryParameter(params)).then(response => {
      VideoRoom.insert({
        data: response.data.data.map(videoRoom => videoRoom.attributes)
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async invitedIndex({ commit, rootGetters }) {
    const apiPath = configureInvitedApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    await http.get(apiPath).then(response => {
      VideoRoom.delete(videoRoom => {
        return videoRoom.invitedByUserId(rootGetters['auth/signedInUser'].id)
      })
      VideoRoom.insert({
        data: response.data.data.map(videoRoom => videoRoom.attributes)
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async show({ commit, rootGetters }, payload) {
    const { videoRoomMasterId, id } = payload
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      videoRoomMasterId: videoRoomMasterId
    })
    await http.get(apiPath + id).then(response => {
      VideoRoom.insert({
        data: Object.assign(response.data.data.attributes, {
          guestUsers: response.data.data.attributes.temporaryGuestUserIds.map((temporaryGuestUserId) => {
            return response.data.included.filter((resource) => resource.type === 'user' && resource.id == temporaryGuestUserId)[0]?.attributes
          })
        })
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async create({ commit, rootGetters }, payload) {
    const { videoRoomMasterId, attributes } = payload
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      videoRoomMasterId: videoRoomMasterId
    })
    const params = JSON.stringify({
      videoRoom: attributes
    })
    let createdVideoRoomId
    await http.post(apiPath, params).then(response => {
      VideoRoom.insert({
        data: response.data.data.attributes
      })
      createdVideoRoomId = response.data.data.id
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
    return createdVideoRoomId
  },
  async update({ commit, rootGetters }, payload) {
    const { videoRoomMasterId, videoRoomId, attributes } = payload
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      videoRoomMasterId: videoRoomMasterId
    })
    const params = JSON.stringify({
      videoRoom: attributes
    })
    await http.put(apiPath + videoRoomId, params).then(response => {
      VideoRoom.insert({
        data: Object.assign(response.data.data.attributes, {
          guestUsers: response.data.data.attributes.temporaryGuestUserIds.map((temporaryGuestUserId) => {
            return response.data.included.filter((resource) => resource.type === 'user' && resource.id == temporaryGuestUserId)[0]?.attributes
          })
        })
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async destroy({ commit, rootGetters }, payload) {
    const { videoRoomMasterId, id } = payload
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      videoRoomMasterId: videoRoomMasterId
    })
    await http.delete(apiPath + id).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
